import React, { useState, useEffect, useContext, useRef} from 'react';
import {IProps} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';

const RotationAddIn: React.FC<IProps> = (props) => {
  const context = useContext(Context);
  return (
    <>
      {
        props.visible && 
        <S.ToolTip top={((props.y??0) +  (context.editorStatus.selectedOffsetY??0))  + 'px'} left={((props.x??0) + (context.editorStatus.selectedOffsetX??0))  + 'px'}>
          {
            props.rotation?Math.round(props.rotation).toString()+"°":""
          }
        </S.ToolTip>
      }
    </>
  );
}
  
export default RotationAddIn;